const customLightbox = {
    props: {
        galleryImages: {
            type: Array,
            default() {
                return [];
            }
        }
        ,
        mainTitle: {
            type: String,
            default: ""
        },
        prevTitle: '',
        nextTitle: '',
        infinite: false
    },
    data: () => {
        return {
            imageLoaded: false,
            selectedItem: null,
            selectedIndex: -1,
            imgUrl: "",
            loadMore: false
        }

    },
    template: `<div class="b-lightbox">
    <div v-if="selectedItem" class="b-lightbox__conts-wrap">
        <div class="b-lightbox__top">
            <h3 class="b-lightbox__title">{{mainTitle}}</h3>
            <button @click="closeLayer" class="btn btn--close"></button>
        </div>
        <div v-if="selectedIndex>=0 && showWhenLoadMore" class="b-lightbox__conts">

            <div v-if="selectedItem.type==='image'" class="b-lightbox__img-wrap">
                <span class="b-lightbox__img-span">
                    <img v-show="imageLoaded" @load="onImgLoad" :src="imgUrl" alt="" />
                    
                    <div class="b-lightbox__btns-mobile" v-if="showWhenLoadMore && imageLoaded">
                        <button @click="prevItem" v-show="showPrev" class="b-lightbox__prev b-lightbox__prev--mobile" :title="prevTitle"></button>
                        <button @click="nextItem" v-show="showNext" class="b-lightbox__next b-lightbox__next--mobile" :title="nextTitle"></button>
                    </div>
                </span>
            </div>
            
            <div v-if="selectedItem.type==='video'" class="b-lightbox__video">
                <div class="circle-loader"></div>
                <div class="b-youtube">
                    <iframe width="560" height="315" :src="selectedItem.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
                
                <div class="b-lightbox__btns-mobile" v-if="showWhenLoadMore">
                    <button @click="prevItem" v-show="showPrev" class="b-lightbox__prev b-lightbox__prev--mobile" :title="prevTitle"></button>
                    <button @click="nextItem" v-show="showNext" class="b-lightbox__next b-lightbox__next--mobile" :title="nextTitle"></button>
                </div>
            </div>

            <div v-if="selectedItem.type==='file'" class="b-lightbox__file">
                <div class="b-media-item">
                    <b-media-item--file :card="selectedItem"></b-media-item--file>
                    
                    <div class="b-lightbox__btns-mobile" v-if="showWhenLoadMore">
                        <button @click="prevItem" v-show="showPrev" class="b-lightbox__prev b-lightbox__prev--mobile" :title="prevTitle"></button>
                        <button @click="nextItem" v-show="showNext" class="b-lightbox__next b-lightbox__next--mobile" :title="nextTitle"></button>
                    </div>
                </div>
            </div>

            <div v-show="!isImageLoaded && selectedItem.type==='image'" class="circle-loader"></div>
        </div>

        <div v-if="!showWhenLoadMore" class="circle-loader"></div>

        <template v-if="showWhenLoadMore">
            <div class="b-lightbox__caption" v-html="selectedItem.desc"></div>
            
                <button @click="prevItem" v-show="showPrev" class="b-lightbox__prev" :title="prevTitle"></button>
                <button @click="nextItem" v-show="showNext" class="b-lightbox__next" :title="nextTitle"></button>
            
        </template>
    </div>
</div>`,
    mounted() {
        jQuery(($) => {

            $(document).keyup((e) => {
                if (e.key === "Escape") { // escape key maps to keycode `27`
                    this.closeLayer()
                } else if (e.key === 37 || e.key === "ArrowLeft") { // left 
                    this.prevItem();
                } else if (e.key === 39 || e.key === "ArrowRight") { // right  
                    this.nextItem();
                }
            });
        })
    },
    methods: {
        showItem(e, index) {
            this.selectedIndex = -1;
            //e.preventDefault()
            this.selectedIndex = index;
            jQuery('html, body').addClass('lightbox-opened')
            
            this.$el.classList.add("opened")
            this.setSelectedItem();
        },
        setSelectedItem() {
            this.imageLoaded = false
            if (this.selectedIndex >= 0 && this.selectedIndex < this.galleryImages.length) {
                this.selectedItem = this.galleryImages[this.selectedIndex]
                this.loadImg()
            }
        },
        closeLayer() {
            jQuery('html, body').removeClass('lightbox-opened')
            this.$el.classList.remove("opened")
            this.imgUrl = ""
            this.selectedIndex = -1;
        },
        nextItem() {
            if(this.infinite && this.selectedIndex === this.galleryImages.length - 1){
                this.loadMore = true
                this.$emit("onloadMore")
                return
            }
            if (this.selectedIndex >= 0 && this.selectedIndex < this.galleryImages.length - 1) {
                this.selectedIndex++
                this.setSelectedItem();
            }
        },
        prevItem() {
            if (this.selectedIndex > 0) {
                this.selectedIndex--
                this.setSelectedItem();
            }
        },
        onImgLoad() {
            this.imageLoaded = true
        },
        loadImg() {
            this.imageLoaded = false
            this.$nextTick(() => {
                if (this.selectedItem.image)
                    this.imgUrl = this.selectedItem.image;
            })
        },
        loadMoreComplete(){
            this.loadMore = false
        }
    },
    computed: {
        showPrev() {
            return this.selectedIndex > 0
        },
        showNext() {
            if(this.infinite){
                return true
            }
            return this.selectedIndex < this.galleryImages.length - 1
        },
        isImageLoaded() {
            return this.imageLoaded
        },
        showWhenLoadMore(){
            if(this.infinite && this.loadMore){
                return false
            }
            return true
        }
    }
}
